import { render, staticRenderFns } from "./EditPostOverlay.vue?vue&type=template&id=a83ea4a4&"
import script from "./EditPostOverlay.vue?vue&type=script&lang=js&"
export * from "./EditPostOverlay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports